<template>
    <div>

        <b-modal id="create-or-update-address" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-address-create-or-update v-model="address" :errors="errors"></employee-address-create-or-update>
            <template #modal-footer><v-executer :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        
        <v-table    ref="table"
                    up-class="px-1 pb-1"
                    with-items
                    search
                    :items="value"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee-address"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeAddressCreateOrUpdate from './EmployeeAddressCreateOrUpdate.vue'
import randomatic from 'randomatic'

export default {
    components:{
        EmployeeAddressCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"İl",key:"ProvinceName",thClass:"w-25"},
                {name:"İlçe",key:"DistrictName",thClass:"w-25"},
                {name:"Posta Kodu",key:"PostalCode",thClass:"w-25"},
                {name:"Adres",key:"Value",thClass:"w-25"},
                {name:"Organizasyonel",key:"Organisational"},
                {name:"Varsayılan",key:"Default"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            address:{
                Id:null,
                Value:null,
                ProvinceId:null,
                ProvinceName:null,
                DistrictId:null,
                DistrictName:null,
                PostalCode:null,
                Default:false,
                Organisational:false,
                EmployeeId:null,
                HomeAddressX:null,
                HomeAddressY:null,
            },
            errors:{},
            editing:false,
        }
    }, 
    methods:{
        clearForm(){
            this.address.editing = false
            this.address.Id = null
            this.address.Value = null
            this.address.ProvinceId = null
            this.address.ProvinceName = null
            this.address.DistrictId = null
            this.address.DistrictName = null
            this.address.PostalCode = null
            this.address.Default = false
            this.address.Organisational = false
            this.address.EmployeeId = null
            this.address.HomeAddressX = null
            this.address.HomeAddressY = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-address')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.address.Id = item.Id
            this.address.Value = item.Value
            this.address.ProvinceId = item.ProvinceId
            this.address.ProvinceName = item.ProvinceName
            this.address.DistrictId = item.DistrictId
            this.address.DistrictName = item.DistrictName
            this.address.PostalCode = item.PostalCode
            this.address.Default = item.Default
            this.address.Organisational = item.Organisational
            this.address.EmployeeId = item.EmployeeId
            this.address.HomeAddressX = item.HomeAddressX
            this.address.HomeAddressY = item.HomeAddressY
            this.$showModal('create-or-update-address')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.address.ProvinceId)){
                this.$set(this.errors,'ProvinceId','İl alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.address.DistrictId)){
                this.$set(this.errors,'DistrictId','İlçe alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.address.Value)){
                this.$set(this.errors,'Value','Adres alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                let id = this.address.Id ? this.address.Id : randomatic("A0",10)
                if(this.address.Id){
                    let item = this.value.find(r=> r.Id == id)
                    this.$set(item,"Value",this.address.Value)
                    this.$set(item,"ProvinceId",this.address.ProvinceId)
                    this.$set(item,"ProvinceName",this.address.ProvinceName)
                    this.$set(item,"DistrictId",this.address.DistrictId)
                    this.$set(item,"DistrictName",this.address.DistrictName)
                    this.$set(item,"PostalCode",this.address.PostalCode)
                    this.$set(item,"Default",this.address.Default)
                    this.$set(item,"Organisational",this.address.Organisational)
                    this.$set(item,"EmployeeId",this.address.EmployeeId)
                    this.$set(item,"HomeAddressX",this.address.HomeAddressX)
                    this.$set(item,"HomeAddressY",this.address.HomeAddressY)
                    this.$set(item,"Unsaved",true)     
                }else{
                    this.value.push({
                        Id:id,
                        Value:this.address.Value,
                        ProvinceId:this.address.ProvinceId,
                        ProvinceName:this.address.ProvinceName,
                        DistrictId:this.address.DistrictId,
                        DistrictName:this.address.DistrictName,
                        PostalCode:this.address.PostalCode,
                        Default:this.address.Default,
                        Organisational:this.address.Organisational,
                        EmployeeId:this.id,
                        HomeAddressX:this.address.HomeAddressX,
                        HomeAddressY:this.address.HomeAddressY,
                        Unsaved:true
                    })
                }
    
                if(this.address.Default == true){
                    this.value.filter(a=> a.Id != id).forEach(a => { this.$set(a,"Default",false) });
                }
    
                this.$hideModal('create-or-update-address')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem adresi silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        }, 
    }
}
</script>

<style>

</style>